import { createContext, useContext, useState, useEffect } from 'react';
import { useSession } from "../../auth/SessionContext";
import { DEBUG } from '../..';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    //const [opened ,{ open: openCart, close: closeCart }] = useDisclosure(false);
    const { sessionData, loadSessionDataAsync } = useSession();
    const [opened, setOpened] = useState(false);
    const [cartProduct, setCartProduct] = useState('lifetime');

    const handleSteamLogin = async (productType = 'lifetime') => {
        try {
          localStorage.setItem('cartProduct', productType);
          window.location.href = "/dyn/auth/init-openId.php?cart";
        } catch (error) {
          if(DEBUG) console.error("Error initiating Steam login:", error);
        }
      };
    const openCart = async (productType) => {
      const resolvedProduct = productType ?? localStorage.getItem('cartProduct') ?? 'lifetime';
      if(DEBUG) console.log("openCart logged_in", sessionData.logged_in, "product", resolvedProduct);
      setCartProduct(resolvedProduct);
      localStorage.setItem('cartProduct', resolvedProduct);
      var result = await loadSessionDataAsync();
      return sessionData.logged_in ? setOpened(true) : handleSteamLogin(resolvedProduct);
    }
    const closeCart = () => setOpened(false);
    useEffect(() => {
      if(DEBUG) console.log("opened cart ", opened);
    }, [opened]);

    return (
        <CartContext.Provider value={{ opened, openCart, closeCart, cartProduct }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);